function getFocusableElements(n)
{
	return Array.from(n.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}

function trapFocus(n, t = n)
{
	var i = getFocusableElements(n),
		r = i[0],
		u = i[i.length - 1];
	removeTrapFocus();
	trapFocusHandlers.focusin = t =>
	{
		(t.target === n || t.target === u || t.target === r) && document.addEventListener("keydown", trapFocusHandlers.keydown)
	};
	trapFocusHandlers.focusout = function ()
	{
		document.removeEventListener("keydown", trapFocusHandlers.keydown)
	};
	trapFocusHandlers.keydown = function (t)
	{
		t.code.toUpperCase() === "TAB" && (t.target !== u || t.shiftKey || (t.preventDefault(), r.focus()), (t.target === n || t.target === r) && t.shiftKey && (t.preventDefault(), u.focus()))
	};
	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);
	t.focus()
}

function focusVisiblePolyfill()
{
	const i = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
	let n = null,
		t = null;
	window.addEventListener("keydown", n =>
	{
		i.includes(n.code.toUpperCase()) && (t = !1)
	});
	window.addEventListener("mousedown", () =>
	{
		t = !0
	});
	window.addEventListener("focus", () =>
	{
		(n && n.classList.remove("focused"), t) || (n = document.activeElement, n.classList.add("focused"))
	}, !0)
}

function pauseAllMedia()
{
	document.querySelectorAll(".js-youtube").forEach(n =>
	{
		n.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
	});
	document.querySelectorAll(".js-vimeo").forEach(n =>
	{
		n.contentWindow.postMessage('{"method":"pause"}', "*")
	});
	document.querySelectorAll("video").forEach(n => n.pause());
	document.querySelectorAll("product-model").forEach(n =>
	{
		n.modelViewerUI && n.modelViewerUI.pause()
	})
}

function removeTrapFocus(n = null)
{
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);
	n && n.focus()
}

function onKeyUpEscape(n)
{
	if (n.code.toUpperCase() === "ESCAPE")
	{
		const t = n.target.closest("details[open]");
		if (t)
		{
			const i = t.querySelector("summary");
			t.removeAttribute("open");
			i.focus()
		}
	}
}

function debounce(n, t)
{
	let i;
	return (...r) =>
	{
		clearTimeout(i), i = setTimeout(() => n.apply(this, r), t)
	}
}

function fetchConfig(n = "json")
{
	return {
		method: "POST",
		headers:
		{
			"Content-Type": "application/json",
			Accept: `application/${n}`
		}
	}
}
const trapFocusHandlers = {};
try
{
	document.querySelector(":focus-visible")
}
catch
{
	focusVisiblePolyfill()
}
class QuantityInput extends HTMLElement
{
	constructor()
	{
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change",
		{
			bubbles: !0
		});
		this.querySelectorAll("button").forEach(n => n.addEventListener("click", this.onButtonClick.bind(this)))
	}
	onButtonClick(n)
	{
		n.preventDefault();
		const t = this.input.value;
		n.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
	}
}
customElements.define("quantity-input", QuantityInput);
class CartNote extends HTMLElement
{
	constructor()
	{
		super();
		this.addEventListener("change", debounce(n =>
		{
			const t = JSON.stringify(
			{
				note: n.target.value
			});
			fetch(`${routes.cart_update_url}`,
			{
				...fetchConfig(),
				...
				{
					body: t
				}
			})
		}, 300))
	}
}
customElements.define("cart-note", CartNote);
const serializeForm = n =>
{
	const t = {},
		i = new FormData(n);
	for (const n of i.keys())
	{
		const r = /(?:^(properties\[))(.*?)(?:\]$)/;
		r.test(n) ? (t.properties = t.properties ||
		{}, t.properties[r.exec(n)[2]] = i.get(n)) : t[n] = i.get(n)
	}
	return JSON.stringify(t)
};
typeof Shopify == "undefined" && (window.Shopify = {});
Shopify.bind = function (n, t)
{
	return function ()
	{
		return n.apply(t, arguments)
	}
};
Shopify.setSelectorByValue = function (n, t)
{
	for (var r, i = 0, u = n.options.length; i < u; i++)
		if (r = n.options[i], t == r.value || t == r.innerHTML) return n.selectedIndex = i, i
};
Shopify.addListener = function (n, t, i)
{
	n.addEventListener ? n.addEventListener(t, i, !1) : n.attachEvent("on" + t, i)
};
Shopify.postLink = function (n, t)
{
	var u, r;
	t = t ||
	{};
	var e = t.method || "post",
		f = t.parameters ||
		{},
		i = document.createElement("form");
	i.setAttribute("method", e);
	i.setAttribute("action", n);
	for (u in f) r = document.createElement("input"), r.setAttribute("type", "hidden"), r.setAttribute("name", u), r.setAttribute("value", f[u]), i.appendChild(r);
	document.body.appendChild(i);
	i.submit();
	document.body.removeChild(i)
};
Shopify.CountryProvinceSelector = function (n, t, i)
{
	this.countryEl = document.getElementById(n);
	this.provinceEl = document.getElementById(t);
	this.provinceContainer = document.getElementById(i.hideElement || t);
	Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
	this.initCountry();
	this.initProvince()
};
Shopify.CountryProvinceSelector.prototype = {
	initCountry: function ()
	{
		var n = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, n);
		this.countryHandler()
	},
	initProvince: function ()
	{
		var n = this.provinceEl.getAttribute("data-default");
		n && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, n)
	},
	countryHandler: function ()
	{
		var n = this.countryEl.options[this.countryEl.selectedIndex],
			r = n.getAttribute("data-provinces"),
			t = JSON.parse(r),
			i;
		if (this.clearOptions(this.provinceEl), t && t.length == 0) this.provinceContainer.style.display = "none";
		else
		{
			for (i = 0; i < t.length; i++) n = document.createElement("option"), n.value = t[i][0], n.innerHTML = t[i][1], this.provinceEl.appendChild(n);
			this.provinceContainer.style.display = ""
		}
	},
	clearOptions: function (n)
	{
		while (n.firstChild) n.removeChild(n.firstChild)
	},
	setOptions: function (n, t)
	{
		for (var r, i = 0, u = t.length; i < t.length; i++) r = document.createElement("option"), r.value = t[i], r.innerHTML = t[i], n.appendChild(r)
	}
};
class MenuDrawer extends HTMLElement
{
	constructor()
	{
		super();
		this.mainDetailsToggle = this.querySelector("details");
		const n = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(n);
		navigator.platform === "iPhone" && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents()
	}
	bindEvents()
	{
		this.querySelectorAll("summary").forEach(n => n.addEventListener("click", this.onSummaryClick.bind(this)));
		this.querySelectorAll("button").forEach(n => n.addEventListener("click", this.onCloseButtonClick.bind(this)))
	}
	addAccessibilityAttributes(n)
	{
		n.forEach(n =>
		{
			n.setAttribute("role", "button"), n.setAttribute("aria-expanded", !1), n.setAttribute("aria-controls", n.nextElementSibling.id)
		})
	}
	onKeyUp(n)
	{
		if (n.code.toUpperCase() === "ESCAPE")
		{
			const t = n.target.closest("details[open]");
			t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t))
		}
	}
	onSummaryClick(n)
	{
		const t = n.currentTarget,
			i = t.parentNode,
			r = i.hasAttribute("open");
		i === this.mainDetailsToggle ? (r && n.preventDefault(), r ? this.closeMenuDrawer(t) : this.openMenuDrawer(t)) : (trapFocus(t.nextElementSibling, i.querySelector("button")), setTimeout(() =>
		{
			i.classList.add("menu-opening")
		}))
	}
	openMenuDrawer(n)
	{
		setTimeout(() =>
		{
			this.mainDetailsToggle.classList.add("menu-opening")
		});
		this.mainDetailsToggle.querySelectorAll("details").forEach(n =>
		{
			n.setAttribute("open", "")
		});
		n.setAttribute("aria-expanded", !0);
		trapFocus(this.mainDetailsToggle, n);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
	closeMenuDrawer(n, t = false)
	{
		n !== undefined && (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach(n =>
		{
			n.classList.remove("menu-opening")
		}), this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), removeTrapFocus(t), this.closeAnimation(this.mainDetailsToggle))
	}
	onFocusOut()
	{
		setTimeout(() =>
		{
			this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
		})
	}
	onCloseButtonClick(n)
	{
		const t = n.currentTarget.closest("details");
		this.closeSubmenu(t)
	}
	closeSubmenu(n)
	{
		n.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(n)
	}
	closeAnimation(n)
	{
		let t;
		const i = r =>
		{
			t === undefined && (t = r);
			const u = r - t;
			u < 400 ? window.requestAnimationFrame(i) : (n.removeAttribute("open"), n.closest("details[open]") && trapFocus(n.closest("details[open]"), n.querySelector("summary")))
		};
		window.requestAnimationFrame(i)
	}
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer
{
	constructor()
	{
		super()
	}
	openMenuDrawer(n)
	{
		this.header = this.header || document.getElementById("shopify-section-header");
		this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
		document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`);
		setTimeout(() =>
		{
			this.mainDetailsToggle.classList.add("menu-opening")
		});
		n.setAttribute("aria-expanded", !0);
		trapFocus(this.mainDetailsToggle, n);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement
{
	constructor()
	{
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this));
		this.addEventListener("keyup", n =>
		{
			n.code.toUpperCase() === "ESCAPE" && this.hide()
		});
		this.classList.contains("media-modal") ? this.addEventListener("pointerup", n =>
		{
			n.pointerType !== "mouse" || n.target.closest("deferred-media, product-model") || this.hide()
		}) : this.addEventListener("click", n =>
		{
			n.target.nodeName === "MODAL-DIALOG" && this.hide()
		})
	}
	show(n)
	{
		this.openedBy = n;
		const t = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		t && t.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia()
	}
	hide()
	{
		document.body.classList.remove("overflow-hidden");
		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia()
	}
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement
{
	constructor()
	{
		super();
		const n = this.querySelector("button");
		n && n.addEventListener("click", () =>
		{
			const t = document.querySelector(this.getAttribute("data-modal"));
			t && t.show(n)
		})
	}
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement
{
	constructor()
	{
		super();
		const n = this.querySelector('[id^="Deferred-Poster-"]');
		n && n.addEventListener("click", this.loadContent.bind(this))
	}
	loadContent()
	{
		if (window.pauseAllMedia(), !this.getAttribute("loaded"))
		{
			const n = document.createElement("div");
			n.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0));
			this.setAttribute("loaded", !0);
			this.appendChild(n.querySelector("video, model-viewer, iframe")).focus()
		}
	}
}
customElements.define("deferred-media", DeferredMedia);
class VariantSelects extends HTMLElement
{
	constructor()
	{
		super();
		this.addEventListener("change", this.onVariantChange);
		this.productState = {
			outofstock: !1,
			instock: !1
		}
	}
	onVariantChange()
	{
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(!0, "", !1);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateStock(), this.setProductState()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
	}
	updateOptions()
	{
		this.options = Array.from(this.querySelectorAll("select"), n => n.value)
	}
	updateMasterId()
	{
		this.currentVariant = this.getVariantData().find(n => !n.options.map((n, t) => this.options[t] === n).includes(!1))
	}
	updateMedia()
	{
		if (this.currentVariant && this.currentVariant.featured_media)
		{
			const n = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
			if (n)
			{
				const t = n.parentElement;
				if (document.querySelector("body").classList.contains("product_sticky") && $(".product-single__media-wrapper").addClass("abc"), t.firstChild != n)
				{
					t.prepend(n);
					document.querySelector("body").classList.contains("product_sticky") && n.classList.remove("abc");
					const i = document.querySelector(`[data-thumbnail-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
					this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header");
					this.stickyHeader && this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
					window.setTimeout(() =>
					{
						t.querySelector(".product-single__media-wrapper").scrollIntoView(
						{
							behavior: "smooth"
						})
					})
				}
			}
		}
	}
	updateURL()
	{
		this.currentVariant && this.dataset.updateUrl !== "false" && window.history.replaceState(
		{}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
	}
	updateVariantInput()
	{
		const n = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
		n.forEach(n =>
		{
			const t = n.querySelector('input[name="id"]');
			t.value = this.currentVariant.id;
			t.dispatchEvent(new Event("change",
			{
				bubbles: !0
			}))
		})
	}
	updatePickupAvailability()
	{
		const n = document.querySelector("pickup-availability");
		n && (this.currentVariant && this.currentVariant.available ? n.fetchAvailability(this.currentVariant.id) : (n.removeAttribute("available"), n.innerHTML = ""))
	}
	removeErrorMessage()
	{
		const n = this.closest("section");
		if (n)
		{
			const t = n.querySelector("product-form");
			t && t.handleErrorMessage()
		}
	}
	renderProductInfo()
	{
		fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then(n => n.text()).then(n =>
		{
			const t = `price-${this.dataset.section}`,
				f = (new DOMParser).parseFromString(n, "text/html"),
				i = document.getElementById(t),
				r = f.getElementById(t);
			r && i && (i.innerHTML = r.innerHTML);
			const u = document.getElementById(`price-${this.dataset.section}`);
			u && u.classList.remove("visibility-hidden");
			this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
		})
	}
	toggleAddButton(n = true, t, i = true)
	{
		const r = document.getElementById(`product-form-${this.dataset.section}`);
		if (r)
		{
			const u = r.querySelector('[name="add"]'),
				f = r.querySelector('[name="add"] > span'),
				e = document.getElementById("notify");
			u && (n ? (u.setAttribute("disabled", !0), t && (f.textContent = t), e.classList.remove("hide")) : (u.removeAttribute("disabled"), f.textContent = window.variantStrings.addToCart, e.classList.add("hide")), !i)
		}
	}
	setUnavailable()
	{
		const n = document.getElementById(`product-form-${this.dataset.section}`),
			i = n.querySelector('[name="add"]'),
			r = n.querySelector('[name="add"] > span'),
			t = document.getElementById(`price-${this.dataset.section}`),
			u = document.getElementById("notify");
		i && (r.textContent = window.variantStrings.unavailable, u.classList.remove("hide"), t && t.classList.add("visibility-hidden"))
	}
	setProductState()
	{
		this.productState.instock = this.currentVariant.available;
		this.productState.outofstock = !this.currentVariant.available
	}
	updateStock()
	{
		const u = this.currentVariant.id,
			t = document.querySelector("#pvr-" + u);
		console.log(t);
		const i = t.getAttribute("data-id");
		console.log(i);
		const r = document.querySelector(".items"),
			n = document.querySelector(".product-inventory .inv");
		r && (r.textContent = i, this.currentVariant.available && (n.classList.add("instock"), n.classList.remove("outstock")), this.currentVariant.available || (n.classList.remove("instock"), n.classList.add("outstock")))
	}
	getVariantData()
	{
		return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
	}
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects
{
	constructor()
	{
		super()
	}
	updateOptions()
	{
		const n = Array.from(this.querySelectorAll("fieldset"));
		this.options = n.map(n => Array.from(n.querySelectorAll("input")).find(n => n.checked).value)
	}
}
customElements.define("variant-radios", VariantRadios)